module.exports = __webpack_public_path__ + "media/images/logos/new_york_times-1e926346239f4926eefc8e9026b6acee.svg";